import { render, staticRenderFns } from "./OrdersBreadCrumb.vue?vue&type=template&id=30b9fa66&scoped=true&"
import script from "./OrdersBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./OrdersBreadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./OrdersBreadCrumb.vue?vue&type=style&index=0&id=30b9fa66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9fa66",
  null
  
)

export default component.exports